import { c as _c } from "react/compiler-runtime";
import { Checkmark2Icon, FontWeights, ListItemText } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { formatUserRoleType, userRoleDescription } from "@utils/data-display";
/**
 * Provides the styling for the menu item that allows the user to select a role.
 */
export function getRoleMenuItemSx({
  isTableCell
}) {
  return {
    textWrap: "wrap",
    width: isTableCell ? "250px" : "undefined"
  };
}

/**
 * Shows the content for a menu item (an option to be selected) when changing roles via dropdown.
 */
export function RoleMenuItem(t0) {
  const $ = _c(17);
  const {
    role,
    isRoleSelected: t1
  } = t0;
  const isRoleSelected = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "& .MuiListItemText-primary": {
        fontSize: "12px",
        fontWeight: FontWeights.SemiBold
      },
      "& .MuiListItemText-secondary": {
        fontSize: "11px",
        fontWeight: FontWeights.Regular
      }
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = isRoleSelected ? "primary.main" : "inherit";
  let t4;
  if ($[1] !== t3) {
    t4 = {
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      color: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== role) {
    t5 = formatUserRoleType(role);
    $[3] = role;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isRoleSelected) {
    t6 = isRoleSelected && <Checkmark2Icon sx={{
      height: "16px",
      width: "16px"
    }} />;
    $[5] = isRoleSelected;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = <Stack sx={t4}>{t5}{t6}</Stack>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== role) {
    t8 = userRoleDescription(role);
    $[11] = role;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== role || $[14] !== t7 || $[15] !== t8) {
    t9 = <ListItemText key={role} sx={t2} primary={t7} secondary={t8} />;
    $[13] = role;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}